<template>
  <div>
    <v-btn
      title="EXCLUA UMA CARTEIRA EXISTENTE."
      class="ml-2"
      @click="dialog_ativo = true"
      icon
    >
      <v-icon size="28">$Trash</v-icon>
    </v-btn>


    <SysDialog
      v-model="dialog_ativo"
      :largura="400"
      titulo="Excluir Carteira"
      ocultar-acoes
      content-class="bra-2"
    >
      <span>Você tem certeza que deseja remover esta carteira?</span>

      <div class="d-flex align-center justify-space-between my-5">
        <v-btn color="#999999" width="calc(50% - 5px)" outlined class="text-transform-none" @click="dialog_ativo = false">
          <span style="color: #013254">Cancelar</span>
        </v-btn>

        <v-btn color="#013254" dark width="calc(50% - 5px)" class="text-transform-none" @click="excluir">
          Confirmar
        </v-btn>
      </div>
    </SysDialog>
  </div>
</template>

<script setup>
import api from "@/api/api";
import {logout} from "@/helpers";
import {ref} from "vue";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

const props = defineProps({
  item: Object,
});

const emit = defineEmits(['item-excluido']);

const dialog_ativo = ref(false);

function excluir() {
  const params = {
    idcomprador: props.item.idcomprador,
    idfornecedor: props.item.idfornecedor,
    idsegmento: props.item.idsegmento || null,
    idsecao: props.item.idsecao || null,
    idcategoria: props.item.idcategoria || null,
    idproduto: props.item.idproduto || null,
  };

  api.delete(`carteiras/v2`, { params })
    .then(() => emit('item-excluido', {}))
    .catch(logout);
}
</script>
